import { render, staticRenderFns } from "./FilialeOverview.vue?vue&type=template&id=2495fbbb&scoped=true"
import script from "./FilialeOverview.vue?vue&type=script&lang=js"
export * from "./FilialeOverview.vue?vue&type=script&lang=js"
import style0 from "./FilialeOverview.vue?vue&type=style&index=0&id=2495fbbb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2495fbbb",
  null
  
)

export default component.exports